import {StorageService} from './services/core/storage.service';
import {OrganisationsService} from './services/core/organisations.service';
import {AuthService} from './services/core/auth.service';
import {UserService} from './services/core/user.service';
import {CustomersService} from './services/customers/customers.service';
import {ServiceFacilitiesService} from './services/core/service-facilities.service';
import {DeviceService} from './services/core/device.service';
import {SyncService} from './services/core/sync.service';
import {ConnectionService} from './services/core/connection.service';
import {LicensesService} from './services/core/licenses.service';
import {TimeoutHelper} from './helpers/timeout-helper';
import {SettingsService} from './services/core/settings.service';
import {TranslationsService} from './services/core/translations.service';

export function initializeApp(
  translationsService: TranslationsService,
  storageService: StorageService,
  licensesService: LicensesService,
  organisationsService: OrganisationsService,
  authService: AuthService,
  userService: UserService,
  customersService: CustomersService,
  serviceFacilitiesService: ServiceFacilitiesService,
  deviceService: DeviceService,
  syncService: SyncService,
  connectionService: ConnectionService,
  settingsService: SettingsService): () => Promise<void> {
  // --- Init core services ---
  return async () => {
    await connectionService.init();
    await deviceService.init();
    await storageService.init();
    await translationsService.init();
    await licensesService.init();
    await settingsService.init();
    await organisationsService.init();
    await authService.init();
    await userService.init();
    await serviceFacilitiesService.init();
    await customersService.init();
    await syncService.init();
    await TimeoutHelper.sleep(500);
  };
}



